import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './controllers/App';
import SessionGuard from './controllers/SessionGuard';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './js/html2canvas.min.js';
// import 'mdbreact/dist/css/mdb.css';

// ดักเซสชันหมดอายุจาก error ของทุก request ไว้ที่เดียว ต้องติดตั้งก่อน render
SessionGuard.install();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
